'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const nutritionModule = angular
  .module('app.scholastic', [])
  .config(nutritionConfig);

nutritionConfig.$inject = ['$routeProvider'];

function nutritionConfig($routeProvider) {
  $routeProvider
    .when('/scholastic-setup', {
      template: `<ngz-scholastic-user-setup></ngz-scholastic-user-setup>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
      },
    })
    .when('/scholastic-setup/:id', {
      template: `<ngz-scholastic-user-setup></ngz-scholastic-user-setup>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
      },
    })
    .when('/scholastic-customers-list', {
      template: `<ngz-scholastic-customer-list list-title="'Free Trial Users'"></ngz-scholastic-customer-list>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Free Trial Users', icon: NAVIGATION_ICON.LIST_ALT }
        ]
      }
    })
}
